import { Fragment } from 'react';
import { ChevronRight, IconsNames } from '@eqi-investimentos/icons/web';
import { Divider, Flex, Link, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { appConfig } from '@/config/app';
import { Drawer } from '@/components/modules/Drawer';
import { Icon } from '@/components/elements/Icon';
import { Thumb } from '@/components/elements/Thumb';

export const SupportDrawer = () => {
  const t = useT();

  return (
    <Drawer
      id={SUPPORT_DRAWER_ID}
      headerContent={<Text size="2xl">{t('drawers.support.header')}</Text>}
      closeButtonProps={{ top: '3.125rem' }}
      bodyProps={{ px: '2xl' }}
      headerProps={{
        pl: '3.4375rem',
        pr: '3rem',
        py: '2.8125rem',
      }}
    >
      <Flex flexDir="column" gap="3xl">
        <Flex direction="column" gap="m">
          <Text size="h6" fontWeight="medium">
            {t('drawers.support.title')}
          </Text>
          <Text size="xl">{t('drawers.support.description')}</Text>
        </Flex>
        <Flex
          flexDir="column"
          gap="2xl"
          py="2xl"
          px="l"
          bgColor="background.brandLight"
          borderRadius="xs"
        >
          <Flex alignItems="center" gap="l">
            <Thumb
              src="/assets/logo_app.png"
              width={56}
              height={56}
              radius={56}
            />
            <Text size="2xl" fontWeight="bold">
              {t('drawers.support.cardTitle')}
            </Text>
          </Flex>
          <Flex flexDir="column" gap="l">
            {contacts.map(({ content, icon, link }) => {
              const hasLink = !!link?.length;
              return (
                <Fragment key={`support-item-${content}`}>
                  <Link
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    display="flex"
                    justifyContent="space-between"
                    w="full"
                    _hover={{
                      color: 'content.brand',
                    }}
                    {...(!hasLink && {
                      as: 'div',
                      cursor: 'default',
                      _hover: { textDecoration: 'none' },
                    })}
                  >
                    <Flex alignItems="center" gap="s">
                      <Icon
                        iconName={icon}
                        width={24}
                        height={24}
                        color="content.brand"
                      />
                      <Text size="xl">{content}</Text>
                    </Flex>
                    {hasLink && (
                      <ChevronRight boxSize="1.5rem" color="content.brand" />
                    )}
                  </Link>
                  <Divider borderColor="border.secondary" />
                </Fragment>
              );
            })}
          </Flex>
        </Flex>
      </Flex>
    </Drawer>
  );
};

export const SUPPORT_DRAWER_ID = 'support-drawer';

const contacts: {
  icon: IconsNames;
  content: string;
  link?: string;
}[] = [
  { icon: 'PhoneFilled', content: '4007-2374' },
  {
    icon: 'Whatsapp',
    content: '+55 (47) 4007-2374',
    link: `${appConfig.support.whatsAppUrlBase}?phone=${appConfig.support.number}&text=${appConfig.support.message}`,
  },
  { icon: 'MailOutline', content: 'atendimento@eqi.com.br' },
];
